import { isNotNullOrEmpty, isEmptyString, isString, isset } from "./validate"

const checkCompanyInputValid = (input) => {
  if (!isNotNullOrEmpty(input)) return false
  if (isNotNullOrEmpty(input) && (isEmptyString(input.email) || isEmptyString(input.nameEN) || !isString(input.email) || !isString(input.nameEN))) return false
  return true
}

export const checkOrderInfoValid = (orderInfo) => {
  if (!isNotNullOrEmpty(orderInfo)) return false
  if (isset(orderInfo.id)) return true
  return false
}

export default checkCompanyInputValid
